import URL from 'url';
import configHandler from '../configHandler';

export default nextState => {
  const config = configHandler();
  const state = encodeURIComponent(btoa(JSON.stringify({
      ledgerId: nextState.params.companyFileId,
      ledgerRegion: nextState.params.region,
      ledgerType: 'arl',
      formType: nextState.params.formType
    }))),
    authUri = URL.parse(config.EXTERNAL_OAUTH_URL),
    clientId = config.EXTERNAL_OAUTH_KEY,
    redirectUri = encodeURIComponent(config.TAXONLINE_SME_DASHBOARD_OAUTH_REDIRECT_URI_ARL),
    scope = `${config.EXTERNAL_AGENCY_API_SCOPE} CompanyFile`;

  authUri.pathname ='/oauth2/account/authorize';
  authUri.search =`client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}`;
  window.location = `${URL.format(authUri)}`
}



// WEBPACK FOOTER //
// ./src/app/helpers/redirectToSts.js